/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Filter_Onlydeleted1Inputs */



/**
* | output |
* | --- |
* | "Deleted only" |
*
* @param {Alarms_Filter_Onlydeleted1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_filter_onlydeleted1 = /** @type {((inputs?: Alarms_Filter_Onlydeleted1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Filter_Onlydeleted1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Deleted only")
	return /** @type {LocalizedString} */ ("Voir les alarmes supprimées")
});
export { alarms_filter_onlydeleted1 as "alarms_filter_onlyDeleted" }